import { render } from "./rub_vnd.vue?vue&type=template&id=d3064570"
import script from "./rub_vnd.vue?vue&type=script&lang=js"
export * from "./rub_vnd.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__